var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContributionOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.5H1.5C0.947715 8.5 0.5 8.94772 0.5 9.5V14.5C0.5 15.0523 0.947715 15.5 1.5 15.5H6.5C7.05228 15.5 7.5 15.0523 7.5 14.5V9.5C7.5 8.94772 7.05228 8.5 6.5 8.5Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9H1.5C1.22386 9 1 9.22386 1 9.5V14.5C1 14.7761 1.22386 15 1.5 15H6.5C6.77614 15 7 14.7761 7 14.5V9.5C7 9.22386 6.77614 9 6.5 9Z",
    stroke: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.5H1.5C0.947715 1.5 0.5 1.94772 0.5 2.5V7.5C0.5 8.05228 0.947715 8.5 1.5 8.5H6.5C7.05228 8.5 7.5 8.05228 7.5 7.5V2.5C7.5 1.94772 7.05228 1.5 6.5 1.5Z",
    fill: "#272D55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2H1.5C1.22386 2 1 2.22386 1 2.5V7.5C1 7.77614 1.22386 8 1.5 8H6.5C6.77614 8 7 7.77614 7 7.5V2.5C7 2.22386 6.77614 2 6.5 2Z",
    stroke: "#272D55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0.5H9.5C8.94772 0.5 8.5 0.947715 8.5 1.5V6.5C8.5 7.05228 8.94772 7.5 9.5 7.5H14.5C15.0523 7.5 15.5 7.05228 15.5 6.5V1.5C15.5 0.947715 15.0523 0.5 14.5 0.5Z",
    fill: "#272D55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1H9.5C9.22386 1 9 1.22386 9 1.5V6.5C9 6.77614 9.22386 7 9.5 7H14.5C14.7761 7 15 6.77614 15 6.5V1.5C15 1.22386 14.7761 1 14.5 1Z",
    stroke: "#272D55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.5H8.5C7.94772 8.5 7.5 8.94772 7.5 9.5V14.5C7.5 15.0523 7.94772 15.5 8.5 15.5H13.5C14.0523 15.5 14.5 15.0523 14.5 14.5V9.5C14.5 8.94772 14.0523 8.5 13.5 8.5Z",
    fill: "#272D55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9H8.5C8.22386 9 8 9.22386 8 9.5V14.5C8 14.7761 8.22386 15 8.5 15H13.5C13.7761 15 14 14.7761 14 14.5V9.5C14 9.22386 13.7761 9 13.5 9Z",
    stroke: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContributionOperationIcon);
export default __webpack_public_path__ + "static/media/ContributionOperationIcon.f950416e9f0e6cb071ad7ba7e424cd24.svg";
export { ForwardRef as ReactComponent };